import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_LISTAR_ATRAS } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import Select from "react-select";
import cargandoCard from "../../../components/cargando-card";
import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";
import { obtenerListaConductores } from "../../../api/api-conductor";
import { actualizarUsuarioMovil, crearUsuarioMovil } from "../../../api/api-usuario-movil";
import { obtenerListaVehiculos } from "../../../api/api-vehiculo";
import { obtenerListaRolUsuarioMovil } from "../../../api/api-rol-usuario-movil";
import { obtenerListaCiudad } from "../../../api/api-ciudad";


const styles = {
  headerContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
  },
  line: {
    flex: 1,
    borderBottom: "1px solid #000",
  },
  headerText: {
    marginRight: "10px",
    fontWeight: "bold",
    fontSize: "16px",
  },
};

export default function UsuarioMovil() {
  const location = useLocation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [titulo, setTitulo] = useState("");
  const [formData, setFormData] = useState({});
  const [listHabilitado, setListHabilitado] = useState([]);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  const [listaConductores, setListaConductores] = useState([]);
  const [conductorSelected, setConductorSelected] = useState(null);

  const [listaVehiculos, setListaVehiculos] = useState([]);
  const [vehiculoSelected, setVehiculoSelected] = useState(null);

  const [listaRol, setListaRol] = useState([]);
  const [rolSelected, setRolSelected] = useState(null);

  const [listaCiudad, setListaCiudad] = useState([]);
  const [ciudadSelected, setCiudadSelected] = useState(null);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.formData);
        setTitulo(data.titulo);
      }
      setListHabilitado(SELECT_HABILITADO_DESHABILITADO);
      // const response = await obtenerInfoVehiculo({ idVehiculo: data.idVehiculo });
      const habilitado = SELECT_HABILITADO_DESHABILITADO.find(e => e.value === data.formData.estado);
      if (habilitado !== undefined) {
        setHabilitadoSelected(habilitado);
      }
      const conductores = await obtenerListaConductores({ habilitado: 1 }, true);
      // console.log('conductores');
      // console.log(conductores);
      setListaConductores(conductores);
      const vehiculos = await obtenerListaVehiculos({ habilitado: 1 }, true);
      // console.log('vehiculos');
      // console.log(vehiculos);
      setListaVehiculos(vehiculos);
      const roles = await obtenerListaRolUsuarioMovil(true);
      // console.log('roles');
      // console.log(roles);
      setListaRol(roles);
      const ciudades = await obtenerListaCiudad(true);
      // console.log('ciudades');
      // console.log(ciudades);
      setListaCiudad(ciudades);
      if (data.formData.idConductor !== undefined && data.formData.idConductor !== null && String(data.formData.idConductor).length > 0) {
        const conductor = conductores.find(e => e.value === data.formData.idConductor);
        if (conductor !== undefined) {
          setConductorSelected(conductor);
        }
      }
      if (data.formData.idVehiculo !== undefined && data.formData.idVehiculo !== null && String(data.formData.idVehiculo).length > 0) {
        const vehiculo = vehiculos.find(e => e.value === data.formData.idVehiculo);
        if (vehiculo !== undefined) {
          setVehiculoSelected(vehiculo);
        }
      }
      if (data.formData.idRol !== undefined && data.formData.idRol !== null && String(data.formData.idRol).length > 0) {
        const rol = roles.find(e => e.value === data.formData.idRol);
        if (rol !== undefined) {
          setRolSelected(rol);
        }
      }
      if (data.formData.idCiudad !== undefined && data.formData.idCiudad !== null && String(data.formData.idCiudad).length > 0) {
        const ciudad = ciudades.find(e => e.value === data.formData.idCiudad);
        if (ciudad !== undefined) {
          setCiudadSelected(ciudad);
        }
      }
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  };

  const charLimits = {
    usuario: 64,
    password: 64,
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validate = () => {
    try {
      let message = "";
      if (vehiculoSelected === null) {
        message = message + "Debe seleccionar vehiculo/unidad" + '\n';
      }
      if (conductorSelected === null) {
        message = message + "Debe seleccionar conductor" + '\n';
      }
      if (String(formData.usuario).trim().length === 0) {
        message = message + "Debe ingresar usuario" + '\n';
      }
      if (String(formData.password).trim().length === 0) {
        message = message + "Debe ingresar password" + '\n';
      }
      if (habilitadoSelected === null) {
        message = message + "Debe seleccionar estado" + '\n';
      }
      if (message.length > 0) {
        alert(message);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validate err');
      console.log(err);
      return false;
    }
  }

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valid = validate();
    if (valid === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.idVehiculo = vehiculoSelected.value;
    objEnviar.idConductor = conductorSelected.value;
    objEnviar.idRol = rolSelected !== null ? rolSelected.value : null;
    objEnviar.idCiudad = ciudadSelected !== null ? ciudadSelected.value : null;
    objEnviar.usuario = formData.usuario;
    objEnviar.password = formData.password;
    objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : 0;
    if (formData.id === 0) {
      // console.log('crear correo');
      const response = await crearUsuarioMovil(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        alert('Se creo correctamente');
        handleCancelClick();
      }
      if (response.error === true) {
        alert('No se pudo crear');
      }
    }
    if (formData.id !== 0) {
      // console.log('actualizar correo');
      const response = await actualizarUsuarioMovil(objEnviar);
      // console.log('modificado');
      // console.log(modificado);
      if (response.error === false) {
        alert('Se modifico correctamente');
        handleCancelClick();
      }
      if (response.error === true) {
        alert('No se pudo modificar');
      }
    }
  };

  const informacionBasicaForm = () => {
    return (
      <>
        {titleForm("Seleccion Basica")}
        <div className="grid grid-cols-12 gap-4 mt-4">
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="conductor">
              Conductor<span className="text-red-500">*</span>
            </label>
            <Select options={listaConductores} isSearchable='true'
              isClearable='true'
              value={conductorSelected}
              onChange={(event) => setConductorSelected(event)}
              placeholder='Seleccione Conductor'
            />
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="vehiculo">
              Vehiculo<span className="text-red-500">*</span>
            </label>
            <Select options={listaVehiculos} isSearchable='true'
              isClearable='true'
              value={vehiculoSelected}
              onChange={(event) => setVehiculoSelected(event)}
              placeholder='Seleccione Vehiculo'
            />
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="rol">
              Rol
            </label>
            <Select options={listaRol} isSearchable='true'
              isClearable='true'
              value={rolSelected}
              onChange={(event) => setRolSelected(event)}
              placeholder='Seleccione Rol'
            />
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="ciudad">
              Ciudad
            </label>
            <Select options={listaCiudad} isSearchable='true'
              isClearable='true'
              value={ciudadSelected}
              onChange={(event) => setCiudadSelected(event)}
              placeholder='Seleccione Ciudad'
            />
          </div>
        </div>
        {titleForm("Credenciales")}
        <div className="grid grid-cols-12 gap-4 mt-4">
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="usuario">
              Usuario<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="usuario"
              name="usuario"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Numero Documento Identidad"
              maxLength={charLimits.usuario}
              onChange={handleChange}
              value={formData.usuario}
              min={0}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.usuario.length}/{charLimits.usuario}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="password">
              Password<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="password"
              name="password"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Numero Licencia"
              maxLength={charLimits.password}
              onChange={handleChange}
              value={formData.password}
              min={0}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.password.length}/{charLimits.password}</p>
          </div>
        </div>
        {titleForm("Extra")}
        <div className="grid grid-cols-12 gap-4 mt-4">
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
              Estado<span className="text-red-500">*</span>
            </label>
            <Select options={listHabilitado} isSearchable='true'
              isClearable='true'
              value={habilitadoSelected}
              onChange={(event) => setHabilitadoSelected(event)}
              placeholder='Seleccione Estado'
            />
          </div>
        </div>
      </>
    );
  };

  const titleForm = (title) => {
    return (
      <div style={styles.headerContainer}>
        <span style={styles.headerText}>{title}</span>
        <div style={styles.line}></div>
      </div>
    );
  }

  const handleAtrasClick = () => {
    history.goBack();
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (cargandoPage === false && formData === null) {
        return (
          <div>
            <label> Sin data</label>
          </div>
        );
      }
      return (
        <div className="m-4">
          <div className="flex justify-between" >
            <h2 className="font-bold">
              {titulo}
            </h2>
            <button
              type="button"
              className={ESTILO_BOTON_LISTAR_ATRAS}
              onClick={handleAtrasClick}
            >
              ATRAS
            </button>
          </div>
          {informacionBasicaForm()}
          <div className="mt-4 flex justify-end">
            <button
              type="button"
              className={ESTILO_BOTON_GENERAL_ACEPTAR}
              onClick={handleSaveClick}
            >
              GUARDAR
            </button>
          </div>
        </div>
      );
    } catch (err) {
      console.log('Conductor render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
